import Helper from "../Helper";

/**
 * This class represents sort component
 */
export default class Sort {

  /**
   * Constructor.
   *
   * @param {String} sortName
   */
  constructor(sortName) {
    this.sortName = sortName;
    this.sortOptionsWrapper = $('[data-sort="' + sortName + '"]');
    this.sortablesWrapper = $('[data-sortables="' + sortName + '"]');
    this.selectedOptionHolder = $('[data-sort-text="' + sortName + '"]')

    if(this.sortOptionsWrapper.length > 0)
      this.init();
  }

  /**
   * This function will initialize sort options selection and sorting of items.
   */
  init() {
    this.sortOptionsWrapper.find('[data-sort-option-name]').click((event) => {
      event.preventDefault();
      let sortOption = $(event.target);
      let optionName = Helper.capitalize(sortOption.data('sortOptionName'));
      let optionWay = sortOption.data('sortWay');
      let sortedList = undefined;

      if(optionWay === 'asc') {
        sortedList = this.sortablesWrapper.find('[data-sortable]').sort((a, b) => {
          return this.compare(a, b, optionName);
        });
      } else {
        sortedList = this.sortablesWrapper.find('[data-sortable]').sort((a, b) => {
          return this.compare(b, a, optionName);
        });
      }

      if(sortedList) {
        // Write new order to a HTML
        sortedList.each((index, element) => {
          this.sortablesWrapper.append($(element));
        });
        window.refreshLoadMore(this.sortName);

        // Update selected option name
        this.selectedOptionHolder.html($(sortOption).html());
      }
    });

    // Sort by default sort option
    this.sortOptionsWrapper.find('[data-sort-option-name]:contains(' + this.selectedOptionHolder.text() + ')').click();
  }

  /**
   * Compares two elements values.
   *
   * @param {Element} a
   * @param {Element} b
   * @param {String} optionName which value to compare
   *
   * @returns {Number} - or + number which decides if a or b should be above other
   */
  compare(a, b, optionName) {
    let output = 0;
    let decisionValue = $(a).data('sortOption' + optionName);

    // If contains : and is not a number then is datetime
    if(isNaN(decisionValue) && decisionValue.includes(':')) {
      let aDate = new Date(decisionValue.split()[0]);
      let bDate = new Date($(b).data('sortOption' + optionName).split()[0]);

      output = aDate.getTime() - bDate.getTime();
    } else {
      output = parseFloat(decisionValue) - parseFloat($(b).data('sortOption' + optionName));
    }

    return output;
  }
}
